/**
 * @note MDN recommended approach to handle animation resets
 * https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_animations/Tips
 * @param element
 * @param className
 */
export const handleRequestAnimationFrame = (
    element: HTMLDivElement,
    className: string
) => {
    element.classList.remove(className);

    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            element.classList.add(className);
        });
    });
};
